import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, debounceTime: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(value);
    }, debounceTime);

    return () => clearTimeout(timeout);
  }, [value]);

  return debouncedValue;
}
